import { SvgIcon } from '@mui/material';

const UploadOnCloud = (props) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                d="M17.9,9C17.4,6.2,15,4,12,4c-3.3,0-6,2.7-6,6c-2.8,0-5,2.2-5,5s2.2,5,5,5h11.5c3,0,5.5-2.5,5.5-5.5C23,11.6,20.8,9.2,17.9,9
	z M15.9,12.4l-0.2,0.2c-0.1,0.1-0.2,0.1-0.4,0.1H14v3.8c0,0.3-0.2,0.5-0.5,0.5h-3c-0.3,0-0.5-0.2-0.5-0.5v-3.8H8.7
	c-0.1,0-0.3-0.1-0.4-0.1l-0.2-0.2c-0.2-0.2-0.2-0.5,0-0.7l3.5-3.5c0.2-0.2,0.5-0.2,0.7,0l3.5,3.5C16.1,11.9,16.1,12.2,15.9,12.4z"
            />
        </SvgIcon>
    );
};

export default UploadOnCloud;
